<ng-container *ngIf="isDisabled; then readonly; else editing"></ng-container>

<ng-template #readonly>
  <nb-form-field>
    <input nbInput
           type="text"
           placeholder="Messstation suchen"
           [ngModel]="value?.name"
           fullWidth
           [disabled]="true" />
  </nb-form-field>
</ng-template>

<ng-template #editing>
  <nb-form-field>
    <input nbInput
           type="text"
           #searchInput
           [ngModel]="value?.name"
           (ngModelChange)="filterText.set($event)"
           placeholder="Messstation suchen"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           fullWidth />
    <button *ngIf="value" nbSuffix nbButton ghost (click)="clear()">
      <nb-icon icon="close-outline"
               pack="eva">
      </nb-icon>
    </button>
  </nb-form-field>

  <ng-template #popoverTemplate>
    <div class="autocomplete-dropdown">
      <nb-list [nbSpinner]="loading()">
        <nb-list-item *ngFor="let building of filteredControlSystems(); trackBy: trackById" (click)="onSelectionChange(building)">
          <div class="building">
            <div class="name">{{ building.name }}</div>
          </div>
        </nb-list-item>
      </nb-list>
    </div>
  </ng-template>
</ng-template>
